import store from '@/store';
import { RECORD_TYPE, processTypeSet } from '@/const/resource';

// -------------------------------------权限-------------------------------------
// 权限验证  make:make:styleType:edit
export function hasPermissions(roleName) {
  if (!roleName || !roleName.length) return true;
  const all_permission = '*:*:*';
  const permissions = store.state && store.state.permissions;
  // 如果是admin用户给予所有权限
  if (permissions.length == 1 && permissions[0] === all_permission) {
    // 如果是admin给予所有权限
    return true;
  } else {
    return roleName.some((el) => permissions.includes(el));
  }
}

// 开关权限验证 id
export function hasBundleSwitch(switchId) {
  // 用户默认是无限制套餐
  const bundleSwitch = store.state.bundleSwitch || [
    {
      id: 36,
      code: 'NO_LIMIT',
      value: true,
      config: null,
    },
  ];
  return bundleSwitch.find((item) => item.id === switchId && item.value);
}
// ----------------------------------------------------------------------------

// 表单序列化
export const serialize = (data) => {
  let list = [];
  Object.keys(data).forEach((ele) => {
    list.push(`${ele}=${data[ele]}`);
  });
  return list.join('&');
};

// 一行排列几个
export function sliceList(list = [], num = 3) {
  let newList = [];
  for (let i = 0; i < list.length; i += num) {
    newList.push(list.slice(i, i + num));
  }
  return newList;
}

/* 节流函数，
handler:要执行的方法
wait：每次点击事件执行的时间间隔(毫秒)
*/
export function throttle(fn, wait = 1000) {
  let timer;
  return function () {
    if (timer != null) return;
    const context = this;
    const args = arguments;
    fn.apply(context, args);
    timer = setTimeout(() => {
      timer = null;
    }, wait);
  };
}

/* 防抖函数，
handler:要执行的方法
wait：每次点击事件执行的时间间隔(毫秒)
*/
export function debounce(handler, wait) {
  let timer = null;
  return function (...args) {
    clearTimeout(timer); // 清除之前的定时器
    timer = setTimeout(() => {
      handler.apply(this, args);
    }, wait);
  };
}

// 获取小数位数
function getDecimalPlaces(num) {
  let str = num.toString();
  if (str.includes('.')) {
    return str.split('.')[1].length;
  } else {
    return 0; // 如果没有小数点，则表示没有小数位
  }
}

//乘法函数，用来得到精确的乘法结果
//说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
//调用：accMul(arg1,arg2)
//返回值：arg1乘以arg2的精确结果
export const accMul = (arg1 = 1, arg2 = 1) => {
  let m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
};

//除法函数，用来得到精确的除法结果
// limitTwoNum 是否保留两位小数
export const accDiv = (arg1, arg2, limitTwoNum = true) => {
  let t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = arg1.toString().split('.')[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    t2 = arg2.toString().split('.')[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  r1 = Number(arg1.toString().replace('.', ''));
  r2 = Number(arg2.toString().replace('.', ''));
  // 处理小数点的问题
  let value = (r1 / r2) * Math.pow(10, t2 - t1);
  // console.log('value', value, getDecimalPlaces(value));
  const num = getDecimalPlaces(value); // 小数位数
  if (limitTwoNum && num > 2) {
    value = value.toFixed(2);
  }
  return value;
};

//加法函数，用来得到精确的加法结果
//说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
//调用：accAdd(arg1,arg2)
//返回值：arg1加上arg2的精确结果
export const accAdd = (arg1 = 0, arg2 = 0) => {
  if (!arg1) return arg2;
  if (!arg2) return arg1;
  let r1, r2, m;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (accMul(arg1, m) + accMul(arg2, m)) / m;
};

//减法函数
export const accSub = (arg1, arg2) => {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  //last modify by deeka
  //动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg2 * m - arg1 * m) / m).toFixed(n);
};

/**
 * 判断是否为空
 */
export function validateNull(val) {
  if (typeof val === 'boolean') {
    return false;
  }
  if (typeof val === 'number') {
    return false;
  }
  if (val instanceof Array) {
    if (val.length === 0) return true;
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true;
  } else {
    if (val === 'null' || val === null || val === 'undefined' || val === undefined || val === '') {
      return true;
    }
    return false;
  }
  return false;
}

/**
 * 拷贝对象
 * @param {Date | Object | Array} value - 值，必传
 */
export const deepClone = (value) => {
  let copyValue;
  if (value === null || typeof value !== 'object') {
    return value;
  }
  if (value instanceof Date) {
    copyValue = new Date();
    copyValue.setTime(value.getTime());
    return copyValue;
  }
  if (value instanceof Array) {
    copyValue = [];
    for (let i = 0; i < value.length; i++) {
      copyValue[i] = deepClone(value[i]);
    }
    return copyValue;
  }
  if (value instanceof Object) {
    copyValue = {};
    for (let attr in value) {
      if (Object.prototype.hasOwnProperty.call(value, attr)) {
        copyValue[attr] = deepClone(value[attr]);
      }
    }
    return copyValue;
  }
  throw new Error('不能拷贝!');
};

// 格式化日期
export const formatDate = (date, type = 'date') => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const M = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  if (type == 'time') {
    return `${y}-${m}-${d} ${h}:${M}:${s}`;
  } else {
    return `${y}-${m}-${d}`;
  }
};

// 获取当前日期
export function getCurrentDate() {
  const date = new Date();
  return formatDate(date);
}

// 获取当前时间
export function getCurrentTime() {
  const date = new Date();
  return formatDate(date, 'time');
}

// 获取当前日期的后面一天日期
export function getNextDate() {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  return formatDate(date);
}

// 获取当前月份的开始日期和结束日期
export function getMonthDateRange() {
  const year = new Date().getFullYear();
  const month = new Date().getMonth() + 1;
  // 当月第一天（月份从0开始计数）
  const startDate = new Date(year, month - 1, 1);
  // 下个月第0天即为当月最后一天
  const endDate = new Date(year, month, 0);
  return [formatDate(startDate), formatDate(endDate)];
}

// 判断两个日期的大小
export function compareDate(date1, date2) {
  if (!date1 || !date2) return false;
  return new Date(date1.replace(/-/g, '/')).getTime() - new Date(date2.replace(/-/g, '/')).getTime();
}

// 将数字转换为对应的样式序号
export function getStyledIndex(number) {
  return String.fromCharCode(0x2460 + number - 1); // 将数字转换为对应的样式序号
}

// 获取数组中对应文本
export function getLabelByValue(array, value, textParam = 'dictLabel', valueParam = 'dictValue') {
  const item = array.find((item) => item[valueParam] == value);
  return item ? item[textParam] : '';
}

// 将对象1中有的属性赋值到对象2中对应属性上 用在popup搜索框 没有值也会赋值过去
export function mergeObjectCopy(queryParams, popupParams) {
  for (const key in popupParams) {
    if (Object.prototype.hasOwnProperty.call(queryParams, key)) {
      queryParams[key] = popupParams[key];
    }
  }
  return queryParams;
}

// 数值千分位格式化
export function numberWithCommas(x) {
  if (!x) return x;
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// 处理步进器
export function beforeStepChange(value, min, max) {
  // console.log(value, min, max);
  if (value !== '') {
    // 如果最小值为0，就不能输入负数
    if (min >= 0) {
      if (value.toString().startsWith('-')) {
        return false;
      }
    }
    // 输入的值不能小于最小值
    if (!validateNull(min) && value < min) {
      return false;
    }
    // 输入的值不能大于最大值
    if (!validateNull(max) && value > max) {
      return false;
    }
    // 最多两位小数
    if (value.toString().split('.')[1] && value.toString().split('.')[1].length > 2) {
      return false;
    }
  }
  return true;
}

// 计算工资
export const computedPrice = (row, type, isOrigin = false) => {
  const { wageType } = row;
  const pieceRateWage = row?.pieceRateWage ?? 0;
  const hourlyWage = row?.hourlyWage ?? 0;
  let totalTimeConsuming = row.totalTimeConsuming || 0;
  let nondefectiveNum = row.nondefectiveNum || 0;
  let total = 0;
  if (!isOrigin) {
    // 是否有修正的数据
    if (!validateNull(row.settlementNum)) {
      nondefectiveNum = Number(row.settlementNum);
    }
    if (!validateNull(row.settlementHour)) {
      totalTimeConsuming = Number(row.settlementHour);
    }
  }
  // 总工资要根据工价方式计算
  const pieceAmount = accMul(nondefectiveNum, pieceRateWage); // 计件工资
  const hourAmount = accMul(totalTimeConsuming, hourlyWage); //计时工资
  if (type === 'piece') {
    if (wageType === RECORD_TYPE.HOURLY) {
      return '--';
    } else {
      total = pieceAmount;
    }
  } else if (type === 'hour') {
    if (wageType === RECORD_TYPE.PIECE_RATE) {
      return '--';
    } else {
      total = hourAmount;
    }
  } else {
    if (wageType === RECORD_TYPE.HOURLY) {
      total = hourAmount;
    } else if (wageType === RECORD_TYPE.PIECE_RATE) {
      total = pieceAmount;
    }
  }
  // 计算结果保留两位小数
  total = Number(total.toFixed(2));
  return '￥' + total;
};

// 计算工资 - 展示未修改的价格
export const computedPriceOrigin = (row, type) => {
  return computedPrice(row, type, true);
};

// 计算良品数量
export const computedNonDefectiveNum = (row) => {
  const { processType, settlementNum, nondefectiveNum } = row;
  const dyeingConvertRate = row.projectBundleItem ? row.projectBundleItem.dyeingConvertRate : 1; // 转换比例
  if (!validateNull(settlementNum)) {
    return settlementNum;
  }
  // 染色 需要将KG转换成件
  if (processType == processTypeSet.DYEING) {
    return Math.ceil(accDiv(nondefectiveNum, dyeingConvertRate)) + `（${nondefectiveNum}kg）`;
  }
  return nondefectiveNum || 0;
};

// 计算数量 如果是染色工序，则根据比例转换成件
export const computedNum = (row, param) => {
  const { processType } = row;
  let originNum = row[param];
  const dyeingConvertRate = row.projectBundleItem ? row.projectBundleItem.dyeingConvertRate : 1; // 转换比例
  // 染色 需要将KG转换成件
  if (processType == processTypeSet.DYEING && originNum > 0) {
    return Math.ceil(accDiv(originNum, dyeingConvertRate)) + `（${originNum}kg）`;
  }
  return originNum || 0;
};

/**
 * @desc 返回中文一
 * @param number  1
 */
export const numberToChinese = (number) => {
  let chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  let chineseUnits = ['', '十', '百', '千', '万', '亿'];

  if (number === 0) {
    return chineseNumbers[0];
  } else if (number >= 10 && number < 20) {
    const digit = number % 10;
    const digitChinese = digit > 0 ? chineseNumbers[digit] : '';
    return '十' + digitChinese;
  }

  let result = '';
  let unitIndex = 0;

  while (number > 0) {
    const digit = number % 10;
    if (digit !== 0 || result !== '') {
      result = chineseNumbers[digit] + chineseUnits[unitIndex] + result;
    }
    number = Math.floor(number / 10);
    unitIndex++;
  }

  return result;
};

// 获取字典标签
export function selectDictLabel(options, value, labelParam = 'dictLabel', valueParam = 'dictValue') {
  let actions = [];
  Object.keys(options).map((key) => {
    if (options[key][valueParam] == '' + value) {
      actions.push(options[key][labelParam]);
      return false;
    }
  });
  return actions.join('');
}

// 获取日期是周几
export function getWeekday(dateStr, type = 1) {
  let weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  if (type == 2) {
    weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  }
  const date = new Date(dateStr);
  const weekday = date.getDay();
  return weekDays[weekday];
}
